// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa","2530": "e96a97f9","2730": "b3bca57d","9988": "b78b2a24",}[chunkId] + ".css"
}